import React from 'react';
import { BookOpenIcon, ShieldCheckIcon } from 'lucide-react';
import { mockupUrl, offerAnchor, productName } from '../data/content';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function Hero() {
  return <section className="bg-brand pb-14 md:pb-16" data-id="element-95" data-mp="9l375k8q6q7o">
      <div className="border-b border-white/10 bg-brand-deep px-4 py-2.5 text-center" data-id="element-96" data-mp="4mi2n8mfxkdf">
        <p className="text-[11px] font-extrabold uppercase tracking-[.3em] text-accent-light md:text-xs" data-id="element-97" data-mp="1297f6cerrfdj">
          Bright Digital Hub
        </p>
      </div>
      <div className="mx-auto max-w-4xl px-4 pt-8 text-center md:pt-10" data-id="element-98" data-mp="xb5whsl99i2l">
        <h1 className="mx-auto max-w-3xl font-black uppercase leading-tight tracking-tight text-white" data-id="element-99" data-mp="s9zypgcqn4m7">
          <span className="block text-xs text-white/85 md:text-sm" data-id="element-100" data-mp="nbf0fmh1qv0e">
            The complete lumbar rehabilitation system for professionals — ready to adapt to your patients
          </span>
          <span className="mt-2 block text-2xl sm:text-3xl md:text-5xl" data-id="element-101" data-mp="381nu37c3sp2w">
            Complete <span className="text-accent-light" data-id="element-102" data-mp="3j897ze322dq2">Lumbar Rehabilitation</span> Bundle
          </span>
        </h1>

        <OfferLink className="mx-auto my-7 max-w-[300px] sm:max-w-[420px]" label={`See the ${productName} offer`} data-id="element-103" data-mp="3o6kdjcmbi22h">
          <img src={mockupUrl} alt={`${productName}: 5 complete volumes and 5 practical bonuses`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-104" data-mp="399tdd14tkmbt" />
        </OfferLink>

        <p className="mx-auto max-w-2xl text-base font-black uppercase leading-relaxed text-white md:text-xl" data-id="element-105" data-mp="359ja3w8ewa0n">
          5 complete volumes + 5 practical bonuses
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-106" data-mp="2vievwyqk8t6v">
          <strong className="text-white" data-id="element-107" data-mp="2hinc2hdd4iky">80 detailed exercises</strong>,{' '}
          <strong className="text-white" data-id="element-108" data-mp="2lkqy1zxnr5kh">48 structured rehabilitation sessions</strong>, and{' '}
          <strong className="text-white" data-id="element-109" data-mp="s21gq7e3o5xv">12 patient-based programs</strong> covering lumbar mobility, strengthening,
          progressive loading, and functional rehabilitation.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-white/85 md:text-base" data-id="element-110" data-mp="n9i53fyz3kvp">
          Step-by-step instructions, sets, repetitions, rest periods, regressions, and progressions — all organized in
          one professional collection.
        </p>
        <p className="mt-5 text-xs font-black uppercase tracking-wider text-white md:text-sm" data-id="element-111" data-mp="1b0drfxkntnvk">
          Less time searching. <span className="text-accent-light" data-id="element-112" data-mp="162m3tfr1snx6">More clarity in every session.</span>
        </p>

        <div className="mt-7" data-id="element-113" data-mp="110wpnr8j3u4v">
          <Button href={offerAnchor} size="lg" subtext="Get instant digital access today" data-id="element-114" data-mp="x14kzpm9a84s">
            Yes! I want the complete system
          </Button>
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/85" data-id="element-115" data-mp="3lu9xn2arm0br">
          <li className="flex items-center gap-1.5" data-id="element-116" data-mp="1x9kwertfdeju">
            <BookOpenIcon className="h-4 w-4 text-accent-light" aria-hidden="true" data-id="element-117" data-mp="1xb5q6f7x0tgn" /> Instant Digital Access
          </li>
          <li className="flex items-center gap-1.5" data-id="element-118" data-mp="218jw9y0aul4f">
            <ShieldCheckIcon className="h-4 w-4 text-accent-light" aria-hidden="true" data-id="element-119" data-mp="268y3jdu2tr1e" /> 7-Day Guarantee
          </li>
        </ul>
      </div>
    </section>;
}